import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaskPropertiesObject } from 'src/app/models/tasks/tasks-properties/task-properties/task-properties-object.model';
import { AppService } from 'src/app/app.service';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { MatDialog, MatDialogRef } from '@angular/material';
import { JsonComponent } from 'src/app/core/json/json.component';
import { TasksService } from 'src/app/services/api/tasks/tasks.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { DiagramComponent } from 'src/app/core/diagram/diagram.component';

@Component({
  selector: 'app-task-properties',
  templateUrl: './task-properties.component.html',
  styleUrls: ['./task-properties.component.css']
})
export class TaskPropertiesComponent implements OnInit, OnChanges {

  taskProperties: TaskPropertiesObject;
  appData: any;
  @Input() taskDetails: TaskDetailsObject;

  orderId: string;

  jsonRef: MatDialogRef<JsonComponent>;
  diagramRef: MatDialogRef<DiagramComponent>;
  summaryJson: any;
  
  constructor(private appService: AppService,
              private notificationsService: NotificationsService,
              private translateService: TranslateService,
              private tasksService: TasksService,
              public dialog: MatDialog) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.taskDetails) {
      this.taskProperties = this.taskDetails.getProperties().getTaskProperties();
      this.orderId = this.taskDetails.getProperties().getBusinessProperties().getCrmId();
    }
  }

  ngOnInit() {
    this.appData = this.appService.settings;

    this.taskProperties = this.taskDetails.getProperties().getTaskProperties();
    this.orderId = this.taskDetails.getProperties().getBusinessProperties().getCrmId();
  }

  public getTaskProcessFlowChart() {
    this.tasksService.getTaskProcesses(this.taskProperties.getTaskProcessId()).subscribe(
      (data: string) => {
        /*
        this.diagramRef = this.dialog.open(DiagramComponent, {
          data: { title: 'Diagrama de procesos', diagram: data }
        });
        */
        const diagramWindow = window.open('', '_blank');
        diagramWindow.document.write(data);
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('TASKS_KEY.diagramError'), NotificationLevel.ERROR);
      }
    )
  }

  public showTaskServiceSummary() {
    this.tasksService.getTaskServiceSummary(this.taskProperties.getTaskService()).subscribe(
      (data) => {
        this.summaryJson = data;
        delete this.summaryJson._links;
        this.jsonRef = this.dialog.open(JsonComponent, {
          data: { title: 'Sumario del servicio de la tarea', json: this.summaryJson },
          width: '850px'
        });
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('TASKS_KEY.summaryError'), NotificationLevel.ERROR);
      }
    )
  }

  public goToOrder() {
    window.open(
      `${this.appData.baseUrl}${this.appData.basePath}/provision/orders/detail` +
      `?id=${this.orderId}` +
      `&map=${this.taskProperties.getTaskService()}` +
      `&type=${this.taskProperties.getTaskOrderType().toLowerCase()}` +
      `&tab=general`, '_blank');
  }

}